import { Controller } from 'stimulus';

class BadgeModifierController extends Controller {
  static targets = ['badge'];

  /**
   * Selects the first badge target and removes the class attribute that is
   * associated and sets the class attribute with the standard badge class and
   * the textContent as the modifier in the badge class
   *
   * @returns {void}
   */
  applyBadgeVariant() {
    const badge = this.badgeTarget;

    const badgeModifier = badge.textContent.toLowerCase();

    badge.removeAttribute('class');
    badge.setAttribute(
      'class',
      `pro-Badge-tagItem pro-Badge-tagItem--${badgeModifier}`
    );
  }
}

export default BadgeModifierController;
